import {
  MdArrowBack,
  MdBusinessCenter,
  MdCheckCircle,
  MdClose,
  MdEmail,
  MdInfoOutline,
  MdPersonOutline,
} from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@gbs-monorepo-packages/common';
import { colors, radii } from '@gbs-monorepo-packages/styles';

export const PageWrapper = styled.div`
  inset: 0;
  position: fixed;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const IconButton = styled.button`
  align-items: center;
  all: unset;
  border-radius: ${radii.px};
  color: ${colors.text};
  cursor: pointer;
  display: inline-flex;
  font-size: 1.25rem;
  height: 2rem;
  justify-content: center;
  width: 2rem;

  &:hover {
    background-color: ${colors.backgroundHover};
  }

  &:focus-visible {
    outline: 2px solid ${colors.fieldFocus};
    outline-offset: 2px;
  }
`;

export const BackIcon = styled(MdArrowBack)``;
export const CloseIcon = styled(MdClose)``;
export const PersonIcon = styled(MdPersonOutline)``;
export const EmailIcon = styled(MdEmail)``;
export const CompanyIcon = styled(MdBusinessCenter)``;
export const SuccessIcon = styled(MdCheckCircle)``;
export const InfoIcon = styled(MdInfoOutline)``;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  margin: 0;
`;

export const Description = styled.p`
  color: ${colors.textLight};
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const FieldLabel = styled.label`
  color: ${colors.text};
  font-size: 0.875rem;
  font-weight: 600;
`;

export const FieldControl = styled.div<{ $isInvalid?: boolean }>`
  align-items: center;
  background-color: ${colors.white300};
  border-radius: ${radii.lg};
  border: 1px solid
    ${({ $isInvalid = false }) =>
      $isInvalid ? colors.red300 : colors.authPagesFieldBorder};
  display: flex;
  gap: 0.5rem;
  padding: 0 0.75rem;

  &:focus-within {
    border-color: ${({ $isInvalid = false }) =>
      $isInvalid ? colors.red300 : colors.fieldFocus};
  }

  svg {
    color: ${colors.labelText};
    flex-shrink: 0;
    font-size: 1.125rem;
  }
`;

export const Input = styled.input`
  background: transparent;
  border: none;
  color: ${colors.text};
  flex: 1;
  font-size: 1rem;
  height: 2.5rem;
  outline: none;
  width: 100%;

  &::placeholder {
    color: ${colors.labelText};
  }
`;

export const FieldError = styled.p`
  color: ${colors.red300};
  font-size: 0.75rem;
  margin: 0;
`;

export const SubmitButton = styled(Button)`
  all: unset;
  align-items: center;
  background-color: ${colors.blue400};
  border-radius: ${radii.lg};
  color: ${colors.white300};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 0.5rem;

  &:hover {
    opacity: 0.9;
  }
`;

export const LegalText = styled.p`
  color: ${colors.textLight};
  font-size: 0.75rem;
  line-height: 1.5;
  margin: 0;
  text-align: center;
`;

export const LegalLink = styled(Link)`
  color: ${colors.authPagesLink};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ConfirmationContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
`;

export const SuccessIconWrapper = styled.div`
  align-items: center;
  color: ${colors.green300};
  display: flex;
  font-size: 3.5rem;
  justify-content: center;
`;

export const ConfirmationTitle = styled.h1`
  font-size: 1.5rem;
  margin: 0;
`;

export const ConfirmationDescription = styled.p`
  color: ${colors.textLight};
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
`;

export const BackToLoginButton = styled(Link)`
  align-items: center;
  border: 1px solid ${colors.blue400};
  border-radius: ${radii.lg};
  color: ${colors.blue400};
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  height: 2.5rem;
  justify-content: center;
  margin-top: 0.5rem;
  text-decoration: none;
  width: 100%;

  &:hover {
    background-color: ${colors.backgroundHover};
  }
`;

export const NextStepsBox = styled.div`
  align-items: flex-start;
  background-color: ${colors.statusInfo};
  border-radius: ${radii.lg};
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
  padding: 1rem;
  text-align: left;
  width: 100%;
`;

export const NextStepsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const NextStepsTitle = styled.p`
  color: ${colors.text};
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
`;

export const NextStepsDescription = styled.p`
  color: ${colors.textLight};
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 0;
`;

export const FormError = styled.p`
  color: ${colors.red300};
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
`;
